import NextI18NextInstance from 'config/i18n';

export default NextI18NextInstance.i18n as I18n;

type I18n = {
  t: (str: string) => string;
  changeLanguage: (lang: string) => void;
};
